<template>
  <div class="module">
    <h1 class="page-title">Classements</h1>
    <p class="intro">Choisissez votre Ligue pour consulter son classement général ou celui de l'un de ses Comités.</p>

    <div class="national-link">
      <router-link to="/classement/national" class="lb-btn">
        <i class="fa-solid fa-flag"></i> Voir le classement national FFD
      </router-link>
    </div>

    <div v-if="loading" class="lb-loading">Chargement...</div>
    <p v-else-if="!ligues.length" class="lb-loading">Aucune ligue disponible.</p>

    <div v-else class="entity-grid">
      <router-link v-for="ligue in ligues" :to="`/classement/${encodeURIComponent(ligue.code)}`" class="entity-card"
        :key="ligue.id">
        <img v-if="logoUrl(ligue.logo)" :src="logoUrl(ligue.logo)!" :alt="`Logo ${ligue.name}`" class="entity-logo" />
        <div v-else class="entity-logo placeholder"><i class="fa-solid fa-shield-halved"></i></div>
        <span class="entity-name">{{ ligue.name }}</span>
        <span class="entity-code">{{ ligue.code }}</span>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { fetchLigues, logoUrl, type Jurisdiction } from '@/functions/leaderboards';

const ligues = ref<Jurisdiction[]>([]);
const loading = ref(true);

onMounted(async () => {
  try {
    ligues.value = await fetchLigues();
  } catch {
    ligues.value = [];
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.national-link {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}
</style>
